import React from "react";
import {Card, Image, Typography} from "antd";
import TableLongText from "../TableLongText";
const {Paragraph} = Typography

const ReligionVenueCard = ({imageUrl, name, region, religion, onClick, hoverable = true, cardStyle = {}}) => {
    return (
        <Card
            onClick={onClick}
            style={{...cardStyle}}
            size='small'
            hoverable={hoverable}
            cover={
                <Image
                    height={200}
                    preview={false}
                    style={{objectFit: 'cover'}}
                    src={imageUrl}
                />
            }
        >
            <Paragraph style={{marginBottom: 5}} strong>{name}</Paragraph>
            <TableLongText style={{marginBottom: 5}} row={1} text={region}/>
            <TableLongText style={{marginBottom: 5}} row={1} text={religion}/>
        </Card>
    )
}

export default ReligionVenueCard